import request from 'superagent'
import { useMutation } from 'react-query'
import { getApiServer } from '../../utils/domain'
import { CustomHttpError } from '../../types/CustomHttpError'

export default function useLoginUser() {
  return useMutation(
    (values: any) => request.post(`${getApiServer()}/auth/login`).set('Accept', 'application/json').send(values).withCredentials().then((res) => res.body), {
    onError: (error: CustomHttpError) => {
      return error.response.text
    }
  })
}